import { createFileRoute, notFound } from '@tanstack/react-router';
import { lazyScreen } from '@/shared/screen';

// /dev/produtos-credito (só dev): as telas reais sobre o backend em memória.
export const Route = createFileRoute('/dev/produtos-credito/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound é o contrato do Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'default') : () => null,
});
